module.exports = __webpack_public_path__ + "static/img/22.1a731ef9.gif";